/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

import { Svg__notch } from "components/svg/svg";

/**
 * styled components
 */

const Cell = styled.div`
  ${t.mixins.flex()}
  padding: 2px ${t.grid.space1};
  ${t.mixins.rem(13, 21)}
  font-family: ${t.font.primary};
  text-align: center;
  color: ${t.color.darkGrey};
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: ${t.color.greyGallery};
  min-width: 200px;
  max-width: 200px;
  background-color: ${props => props.background};

  @media (max-width: 960px) {
    min-width: 134px;
    max-width: 134px;
    border: 0;
    background-color: ${props => props.smBackground};
  }

  ${({ first }) =>
    first &&
    `
      position: absolute;
      left: 0;
      display: block;
      height: 100%;
      z-index: 2;
      min-width: 159px;
      max-width: 159px;
      ${t.mixins.rem(13, 14)}
      font-weight: ${t.font.bold};
      text-align: left;

      ${t.mixins.sm(`
        position: sticky;
        left: 0;
        right: 0;
        min-width: 100vw;
        height: auto;
        background-color: ${t.color.greySilver};
        text-align: center;
        padding: 6px 0 4px 0;
      `)}
    `}
`;

/**
 * cell component is..
 */

const Table__cell = ({ children, first, odd, index, className, colOdd }) => {
  let background = "transparent";
  if (first) background = t.color.greyAlabaster;
  if (odd) background = t.color.greyGallery;
  const smBackground = colOdd ? t.color.lightGrey : t.color.white;
  return (
    <Cell
      first={first}
      background={background}
      index={index}
      className={className}
      smBackground={smBackground}
    >
      {children}
      {children === true && <Svg__notch />}
      {children === false && "-"}
    </Cell>
  );
};

export default Table__cell;

Table__cell.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Table__cell.defaultProps = {
  style: {},
};

/*
    import Table__cell from 'components/table/cell/table__cell'
    <Table__cell />
  */
